module.exports = __webpack_public_path__ + "img/home-icon.8d8fef55.png";